import {
    ICreateMenuItemModifierSetRequest,
    IDeleteMenuItemModifierSetRequest,
    IUpdateMenuItemModifierSetExternalSettingsRequest,
    IUpdateMenuItemModifierSetRequest
} from "../../../../services/menu/requestsResponses";
import {
    deleteModifiersSet,
    getModifiersSet,
    createModifiersSet,
    updateModifiersSet,
    updateModifiersSetExternalSettings
} from "../../../../services/menu";
import { ExecutionStatus } from "../../../../services/general/requestsResponses";
import { action, computed, makeAutoObservable, runInAction } from "mobx";
import { localize } from "../../../../common/libs";
import { MenuItemModifier, MenuItemModifierSet } from "../../../../services/menu/models";
import ModifiersFormStore from "./forms";


class ModifiersSetsStore{

    constructor() {
        makeAutoObservable(this);
    }


    modifiersSets: MenuItemModifierSet[] = [];
    modifier: MenuItemModifier;
    isLoaded: boolean = false;
    forms: ModifiersFormStore = new ModifiersFormStore();

    async createModifiersSet(params: ICreateMenuItemModifierSetRequest) {
        const response = await createModifiersSet(params);
        await this.loadModifiersSet();
        return response.menuItemModifierSetId;
    }

    async updateModifiersSet(params: IUpdateMenuItemModifierSetRequest) {
        const response = await updateModifiersSet(params);
        await this.loadModifiersSet();
    }
    async updateModifiersSetExternalSettings(params: IUpdateMenuItemModifierSetExternalSettingsRequest) {
        const response = await updateModifiersSetExternalSettings(params);
        await this.loadModifiersSet();
    }

    async removeModifiersSet(params: IDeleteMenuItemModifierSetRequest) {
        const res = await deleteModifiersSet(params);
        await this.loadModifiersSet();
        return {
            err: res.executionStatus !== ExecutionStatus.Finished
        };
    }

    async loadModifiersSet() {
        runInAction(() => {
            this.isLoaded = false;
        })
        const response = await getModifiersSet();
        runInAction(() => {
            this.modifiersSets = response.sets;
            this.isLoaded = true;
        })
    }


    @computed
    getModifiersSetById(id: number) {
        return this.modifiersSets.find(item => item.id === id);
    }


    searchForModifiersSets(query: string) {
        if (query.length === 0) return [...this.modifiersSets];
        return this.modifiersSets.filter(item => {
            const t = localize(item.data.name).toLowerCase().search(query.toLowerCase());
            return t >= 0;
        })
    }


    async ensureLoaded() {
        if (!this.isLoaded) {
            await this.loadModifiersSet();
        }
    }



}

export default ModifiersSetsStore;
